import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DocumentationAuthResponse {
  url: string
}

export type DocumentationVersion = 'v1' | 'v2';

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {
  private http = inject(HttpClient);

  getDocumentationAuthUrl(version: DocumentationVersion = 'v2'): Observable<DocumentationAuthResponse> {
    return this.http.get<DocumentationAuthResponse>(`${environment.apiUrl}/documentation/token`, {
      params: { version }
    });
  }
}
